<template>
    <div class="">
        <input id="date" type="date" :max="maxDate" @input="$emit('input', $event.target.value)" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            maxDate: this.getTodayDate(), // Set the max date to today's date
        };
    },

    methods: {
        getTodayDate() {
            const today = new Date();

            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // Format the date to 'YYYY-MM-DD' which is accepted by the date input
            const formattedDate = `${year}-${month}-${day}`;

            return formattedDate;
        },
    },
};
</script>

<style scoped>
input[type='date'] {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.icon-error {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
}
</style>
